import { useState, useRef, useEffect } from 'react';
import { categories, mainSiteUrl } from '@/mocks/categories';

interface DropdownMenuProps {
  hasBg: boolean;
}

export default function DropdownMenu({ hasBg }: DropdownMenuProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap font-label transition-colors ${
          hasBg
            ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
            : 'bg-white/20 backdrop-blur-sm text-white hover:bg-white/30 border border-white/30'
        }`}
      >
        Categories
        <span className={`transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}>
          <i className="ri-arrow-down-s-line"></i>
        </span>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-64 bg-background-50 border border-background-200 rounded-lg shadow-lg z-50 max-h-[420px] overflow-y-auto">
          <div className="p-2">
            {categories.map((cat) => (
              <a
                key={cat.seq}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setIsOpen(false)}
                className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-accent-600 rounded-md transition-colors whitespace-nowrap font-label"
              >
                {cat.name}
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}